// extracted by mini-css-extract-plugin
module.exports = {"container":"ScommesseTableRowConditional_container__CI9j_","dateHour":"ScommesseTableRowConditional_dateHour__kjYAa","title":"ScommesseTableRowConditional_title__imTRy"};